import qs from 'qs';
import styles from './ProductDetail.module.scss';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import gambichDetail1 from '../../assets/gambichaDetail1.png';
import gambichDetail2 from '../../assets/gambichaDetail2.png';
import gambichDetail3 from '../../assets/gambichaDetail3.png';
import gambichDetail4 from '../../assets/gambichaDetail4.jpg';
import gambichDetailMobile1 from '../../assets/gambichaDetailMobile1.png';
import gambichDetailMobile2 from '../../assets/gambichaDetailMobile2.png'
import gambichDetailMobile3 from '../../assets/gambichaDetailMobile3.png'
import gambichDetailMobile4 from '../../assets/gambichaDetailMobile4.png'
import biumhwanDetail1 from '../../assets/biumhwanDetail1.png';
import biumhwanDetail2 from '../../assets/biumhwanDetail2.png';
import biumhwanDetail3 from '../../assets/biumhwanDetail3.png';
import biumhwanDetail4 from '../../assets/biumhwanDetail4.png';
import biumhwanDeatilMobile1 from '../../assets/biumhwanDetailMobile1.png';
import biumhwanDeatilMobile2 from '../../assets/biumhwanDetailMobile2.png';
import biumhwanDeatilMobile3 from '../../assets/biumhwanDetailMobile3.png';
import biumhwanDeatilMobile4 from '../../assets/biumhwanDetailMobile4.png';
import cheongdamDetail1 from '../../assets/cheongdamDetail1.png';
import cheongdamDetail2 from '../../assets/cheongdamDetail2.png';
import cheongdamDetail3 from '../../assets/cheongdamDetail3.png';
import cheongdamDetail4 from '../../assets/cheongdamDetail4.png';
import cheongdamDetailMobile1 from '../../assets/cheongdamDetailMobile1.png';
import cheongdamDetailMobile2 from '../../assets/cheongdamDetailMobile2.png';
import cheongdamDetailMobile3 from '../../assets/cheongdamDetailMobile3.png';
import cheongdamDetailMobile4 from '../../assets/cheongdamDetailMobile4.png';
import bottomArrow from '../../assets/bottomArrow02.png';
import bottomArrow2 from '../../assets/bottomArrow03.png';
import star from '../../assets/star.png';
import emptyStar from '../../assets/emptyStar.png';
import minus from '../../assets/minus.png';
import plus from '../../assets/plus.png';
import heart from '../../assets/heart.png';
import redHeart from '../../assets/redHeart.png';
import basket from '../../assets/basket.png';
import step from '../../assets/step.png';
import stepDirect from '../../assets/stepDirect.png';
import detailFixFormClose from '../../assets/detailFixFormClose.png';
import closeBtn from '../../assets/closeBtn02.png';
import review01 from '../../assets/review/reviewImage01.jpeg';
import review02 from '../../assets/review/reviewImage02.jpeg';
import review03 from '../../assets/review/reviewImage03.jpeg';
import review04 from '../../assets/review/reviewImage04.jpeg';
import review05 from '../../assets/review/reviewImage05.jpeg';
import couponTicket from '../../assets/couponTicket.png';
import Review from '../../components/Review/Review';
import StepModal from '../StepModal/StepModal';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Scrollbar } from 'swiper';
import 'swiper/css';
import { useEffect, useMemo, useRef, useState } from 'react';
import { throttle } from 'lodash';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import axiosClient from '../../libs/axiosClient';
import { ITokenInfoType, loginCheck } from '../../auth/auth';
import { loginConfirm } from '../../common/loginConfirm';
import ReviewFilter from '../../components/ReviewFilter/ReviewFilter';
import { isDesktop, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { IReviewDataType } from '../MyReview/MyReview';
import LazyLoad from 'react-lazy-load';
import ReactPixel from 'react-facebook-pixel';
import jwt_decode from 'jwt-decode';
import { SHA256 } from 'crypto-js';

import kakao from '../../assets/kakaoLogo2.png';
import axios from 'axios';

declare var ttq: any;
declare var fbq: (...args: any[]) => void;
declare function gtag(...args: any[]): void;

SwiperCore.use([Scrollbar]);
export interface IAllItemsType {
  first: IOptionType;
  second?: IOptionType;
  third?: IOptionType;
  count: number;
  key?: number;
}
export interface IProductDetailType {
  // brand_id: null;
  // brand_name: null;
  // company_id: 'mozzi';
  // company_image: null;
  company_name: string;
  content: string;
  cp_delivery_freeprice: number;
  cp_delivery_price: number;
  cp_delivery_use: string;
  delivery_case_price: number;
  delivery_cost: number;
  delivery_description: string;
  delivery_price: number;
  delivery_type: string;
  is_prescription: number;
  delivery_price_info: {
    delivery_company: string;
    delivery_complain_fail: string;
    delivery_complain_ok: string;
    delivery_complain_price: string;
    delivery_date: string;
    delivery_return_addr: string;
  };
  detail_url: string;
  discount_price: number;
  discount_rate: number;
  hashtag: string;
  id: string;
  image: string;
  image2: string;
  image3: string;
  image4: string;
  image5: string;
  is_like: number;
  list_image: string;
  option_depth: number;
  p_shoppingPayFree: number;
  p_shoppingPayPdPrice: number;
  p_shoppingPayPfPrice: number;
  price: number;
  product_id: number;
  provision_notice: null;
  review_score_avg: {
    product_id: number;
    review_point_0_avg: number;
    review_point_1_avg: number;
    review_point_2_avg: number;
    review_point_3_avg: number;
    review_point_total_avg: number;
    review_total_count: number;
  };
  soldout: string;
  stock_count: number;
  title: string;
  is_sales_started: string;
  selling_end_at: string;
  selling_started_at: string;
}
interface IOptionType {
  po_cnt?: number;
  po_color_name?: string;
  po_color_type?: string;
  po_depth?: number;
  po_parent?: string | null;
  po_pcode?: string;
  po_poption_supplyprice?: number;
  po_poptionname?: string;
  po_poptionprice?: number;
  po_salecnt?: number;
  po_sort?: number;
  po_temp_cosuid?: string | null;
  po_uid: number;
  po_view?: string;
}

interface ProductDescriptionProps {
  detail: IProductDetailType;
}

function ProductDetail() {
  const tagNum = [12, 13, 16, 17];
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [id, setId] = useState('');
  const [tel, setTel] = useState('');
  const [email, setEmail] = useState('');
  const [ip, setIp] = useState('');
  const [activeIndex, setActiveIndex] = useState(1);
  const [detail, setDetail] = useState<IProductDetailType>();
  const { data: detailCacheData } = useQuery<IProductDetailType>(
    ['productDetail', params.productId],
    () =>
      axiosClient
        .get(`/data/product/detail/${params.productId}`)
        .then((res) => {
          let list = JSON.parse(
            sessionStorage.getItem('product_ids') || JSON.stringify([]),
          );
          if (!list.includes(res.data.data.product_id))
            list.push(res.data.data.product_id);
          sessionStorage.setItem('product_ids', JSON.stringify(list));
          return res.data.data;
        }),
    {
      // retry: 2,
      refetchOnWindowFocus: false,
      onError: () => {
        alert('This item is not currently for sale.');
        navigate('/');
      },
      staleTime: 1000 * 60 * 60 * 24,
    },
  );
  const isMobile = window.innerWidth <= 768;
  
  useEffect(() => {
    // Redirect from productId 19 to 39
    if (params.productId === '19') {
      navigate('/productDetail/39', { replace: true });
      return;
    }
  }, [params.productId, navigate]);
  
  useEffect(() => {
    if (detailCacheData) setDetail(detailCacheData);
  }, [detailCacheData]);

  const { t, i18n } = useTranslation();

  // Auto-switch language based on product ID
  // Add product IDs here to use Mongolian language
  const mongolianProductIds = ['48']; // Add more IDs as needed: ['48', '49', '50']

  useEffect(() => {
    if (params.productId && mongolianProductIds.includes(params.productId)) {
      i18n.changeLanguage('mn');
    } else {
      i18n.changeLanguage('en');
    }
  }, [params.productId, i18n]);

  // 옵션 관련 상태
  const [firstOptionOpen, setFirstOptionOpen] = useState(false);
  const [selectedFirstOption, setSelectedFirstOption] = useState<IOptionType>();
  const [secondOptionOpen, setSecondOptionOpen] = useState(false);
  const [selectedSecondOption, setSelectedSecondOption] =
    useState<IOptionType>();
  const [thirdOptionOpen, setThirdOptionOpen] = useState(false);
  const [selectedThirdOption, setSelectedThirdOption] = useState<IOptionType>();
  const [firstOptionList, setFirstOptionList] = useState<IOptionType[]>();
  const [secondOptionList, setSecondOptionList] = useState<IOptionType[]>();
  const [thirdOptionList, setThirdOptionList] = useState<IOptionType[]>();
  const [selectedAllItems, setSelectedAllItems] = useState<IAllItemsType[]>([]);
  const [allItemsPrice, setAllItemsPrice] = useState(0);
  const [allItemsCount, setAllItemsCount] = useState(0);

  const [isStep, setIsStep] = useState(false);

  function generateCoupon(code: number) {
    if (!loginConfirm()) return;
  
    axiosClient
      .post('/func/coupon/create', qs.stringify({ coupon_code: code }))
      .then((res) => {
        if (res.data.result === 'Fail') {
          alert(res.data.data);
        } else {
          alert(t('productDetail.91'));
        }
      })
      .catch((error) => {
        const msg = error.response?.data?.detail;
        if (msg) {
          alert(msg);
        } else {
          alert('An unexpected error occurred.');
        }
      });
  }

  useEffect(() => {
    axiosClient
      .get(`/data/product/detail/${params.productId}/options`)
      .then((res) => setFirstOptionList(res.data.data));
  }, []);
  // 첫 번째 옵션 선택시
  useEffect(() => {
    if (!selectedFirstOption || !detail) return;
    // option_depth가 1보다 크면 2depth의 option 정보 받아옴
    if (detail.option_depth > 1) {
      axiosClient
        .get(
          `/data/product/detail/${detail.product_id}/options?option_id=${selectedFirstOption.po_uid}&depth=2`,
        )
        .then((res) => setSecondOptionList(res.data));
      setSecondOptionOpen(true);
    } else {
      //이미 선택된 옵션 중에 같은 옵션이 포함되어있는지 있으면 해당 idx추출
      let includeIdx = -1;
      selectedAllItems.map((item, idx) => {
        if (item.first?.po_uid == selectedFirstOption.po_uid) includeIdx = idx;
      });
      //-1에서 변경이 없다면 기존 선택된 옵션에 포함되어 있지 않은 옵션이므로 새로 추가
      if (includeIdx == -1)
        setSelectedAllItems([
          ...selectedAllItems,
          {
            first: selectedFirstOption,
            count: 1,
          },
        ]);
      //-1이 아닌 변경된 값이면 이미 해당 옵션이 선택되어 있으므로 해당 옵션 수량 증가
      else
        setSelectedAllItems((prev) => {
          let newList = prev;
          newList[includeIdx].count += 1;
          return [...newList];
        });
      setSelectedFirstOption(undefined);
      setSelectedSecondOption(undefined);
    }
    setFirstOptionOpen(false);
  }, [selectedFirstOption]);
  // 첫 번째 옵션 선택시
  // 두 번째 옵션 선택시
  useEffect(() => {
    if (!selectedSecondOption || !selectedFirstOption || !detail) return;
    if (detail.option_depth > 2) {
      axiosClient
        .get(
          `/data/product/detail/${detail.product_id}/options?option_id=${selectedSecondOption.po_uid}&depth=3`,
        )
        .then((res) => setThirdOptionList(res.data));
      setThirdOptionOpen(true);
    } else {
      let includeIdx = -1;
      selectedAllItems.map((item, idx) => {
        if (
          item.first?.po_uid == selectedFirstOption.po_uid &&
          item.second?.po_uid == selectedSecondOption.po_uid
        )
          includeIdx = idx;
      });
      if (includeIdx == -1)
        setSelectedAllItems([
          ...selectedAllItems,
          {
            first: selectedFirstOption,
            second: selectedSecondOption,
            count: 1,
          },
        ]);
      else
        setSelectedAllItems((prev) => {
          let newList = prev;
          newList[includeIdx].count += 1;
          return [...newList];
        });
      setSelectedFirstOption(undefined);
      setSelectedSecondOption(undefined);
    }
    setSecondOptionOpen(false);
  }, [selectedSecondOption]);
  // 두 번째 옵션 선택시
  function handleCountChange(index: number, isUp: boolean) {
    setSelectedAllItems((prev) =>
      prev.map((item, idx) => {
        if (idx == index) {
          if (isUp) item.count = item.count + 1;
          else if (!isUp && item.count > 1) item.count = item.count - 1;
        }
        return item;
      }),
    );
  }
  function handleSelectedItemDelete(index: number) {
    setSelectedAllItems((prev) => prev.filter((item, idx) => idx !== index));
  }
  // 선택한 옵션 총 가격
  useEffect(() => {
    let newPrice = 0;
    let newCount = 0;
    for (let i = 0; i < selectedAllItems.length; i++) {
      let price = 0;
      if ('third' in selectedAllItems[i])
        price += selectedAllItems[i].third?.po_poptionprice || 0;
      else if ('second' in selectedAllItems[i])
        price += selectedAllItems[i].second?.po_poptionprice || 0;
      else if ('first' in selectedAllItems[i])
        price += selectedAllItems[i].first?.po_poptionprice || 0;
      newPrice = newPrice + price * selectedAllItems[i].count;
      newCount = newCount + selectedAllItems[i].count;
    }
    setAllItemsPrice(newPrice);
    setAllItemsCount(newCount);
  }, [selectedAllItems]);
  // 선택한 옵션 총 가격
  // 옵션 관련 상태

  useEffect(() => {
    if (!detail) return;

    if (window.location.search.includes('?step-recommendation')) {
      setIsStep(true);
    } else {
      setIsStep(false);
    }
  }, [window.location.search]);

  function needLogin() {
    return loginConfirm();
  }
  function getBasketFormData() {
    if (!detail) return;
    let formData = new FormData();
    formData.append('product_id', String(detail.product_id));
    for (let i = 0; i < selectedAllItems.length; i++) {
      if (detail.option_depth <= 1) {
        if (!selectedAllItems[i].first?.po_uid)
          formData.append('option_ids', '0');
        else
          formData.append(
            'option_ids',
            String(selectedAllItems[i].first?.po_uid),
          );
        formData.append('counts', String(selectedAllItems[i].count));
      } else if (detail.option_depth == 2) {
        formData.append(
          'option_ids',
          String(selectedAllItems[i].second?.po_uid),
        );
        formData.append('counts', String(selectedAllItems[i].count));
      } else if (detail.option_depth == 3) {
        formData.append(
          'option_ids',
          String(selectedAllItems[i].third?.po_uid),
        );
        formData.append('counts', String(selectedAllItems[i].count));
      }
    }
    return formData;
  }
  function optionSelectCheck() {
    if (selectedAllItems.length == 0) {
      if (!selectedFirstOption) {
        alert(t('other.34'));
        setFirstOptionOpen(true);
      } else if (!selectedSecondOption) {
        alert(t('other.35'));
        setSecondOptionOpen(true);
      } else if (!selectedThirdOption) {
        alert(t('other.36'));
        setThirdOptionOpen(true);
      }
      return false;
    } else {
      return true;
    }
  }
  function saleDateCheck() {
    if (detail?.is_sales_started == 'N') {
      alert(t('other.55'));
      return false;
    } else return true;
  }

  // IP 가져오기
  useEffect(() => {
    axios.get('https://geolocation-db.com/json/').then((res) => {
      setIp(res.data.IPv4);
    });

    const token = localStorage.getItem('token');
    if (token == null || token == 'null') return;
    try {
      const decodedUserInfo: ITokenInfoType = jwt_decode(token!);
      setId(SHA256(decodedUserInfo.member_id).toString());
      setTel(
        SHA256(decodedUserInfo.phone.trim().replace(/-/gi, '')).toString(),
      );
      setEmail(SHA256(decodedUserInfo.email).toString());
    } catch (err) {}
  }, []);

  function handleBasket() {
    // 비로그인용 장바구니 코드 삽입 필요
    if (!saleDateCheck()) return;
    let check = optionSelectCheck();
    if (!check) return;
    let formData: any = getBasketFormData();

    axiosClient
      .post('/func/cart', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Access-Control-Allow-Origin': 'https://api.us.ondoc.co.kr',
        },
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.data.cart_ids[0].message) {
          alert(res.data.data.cart_ids[0].message);
        } else {
          alert(t('other.37'));
          
          fbq('track', 'AddToCart', {
            content_ids: detail?.product_id,
            content_type: 'product',
            value: allItemsPrice.toLocaleString(),
            currency: 'USD',
          });
          
          gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: allItemsPrice,
            items: [
              {
                item_id: detail?.product_id?.toString(),
                item_name: detail?.title,
                price: allItemsPrice,
              },
            ],
          });

          let countsValue = 0;
          let formValues: any = formData.entries();

          for (const pair of formValues) {
            if (pair[0] === 'counts') {
              countsValue = countsValue + Number(pair[1]);
            }
          }

          ttq.track('AddToCart', {
            value: allItemsPrice.toLocaleString(),
            currency: 'USD',
            content_type: 'product',
            contents: [
              {
                content_id: detail?.product_id,
                content_name: detail?.title,
                quantity: countsValue,
                price: allItemsPrice.toLocaleString(),
              },
            ],
            event_id: res.data.data.cart_ids[0].cart_id,
            user: {
              email: email,
              phone: tel,
            },
            page: {
              url: window.location.href,
            },
          });

          if (
            tagNum.some((num) => location.pathname === `/productDetail/${num}`)
          ) {
            let countsValue = 0;
            const cartNum = res.data.data.cart_ids[0].cart_id;

            let formValues: any = formData.entries();
            for (const pair of formValues) {
              if (pair[0] === 'counts') {
                countsValue = countsValue + Number(pair[1]);
              }
            }

            ReactPixel.track('AddToCart', {
              content_ids: detail?.product_id,
              content_type: 'product',
              value: allItemsPrice.toLocaleString(),
              currency: 'USD',
            });
          }
        }
      })
      .catch((err) => {
        alert(t('other.38'));
      });
  }

  useEffect(() => {
    if (tagNum.some((num) => location.pathname === `/productDetail/${num}`)) {
      ReactPixel.track('ViewContent');
    }
  }, []);
  
  useEffect(() => {
    fbq('track', 'ViewContent', {
      content_ids: params.productId,
      content_type: 'product',
      currency: 'USD',
    });
  }, [params.productId]);

  function handlePick() {
    if (!detail) return;
    if (!needLogin()) return;
    if (detail.is_like == 0) {
      setDetail((prev) => ({ ...prev!, is_like: 1 }));
      
      fbq('track', 'AddToWishlist', {
        content_ids: detail.product_id,
        content_name: detail.title,
        content_type: 'product',
        currency: 'USD',
        value: detail.price,
      });
      
      gtag('event', 'add_to_wishlist', {
        currency: 'USD',
        value: detail.price,
        items: [
          {
            item_id: detail.product_id?.toString(),
            item_name: detail.title,
            price: detail.price,
          },
        ],
      });
      
      axiosClient.post('/func/like', {
        target_id: detail.product_id,
        target_type: 'Product',
        like_type: '1',
      });
    } else {
      setDetail((prev) => ({ ...prev!, is_like: 0 }));
      axiosClient.delete(
        `/func/like?target_type=Product&target_id=${detail.product_id}`,
      );
    }
  }
  // 네비게이션 바 관련
  const [hitNavigation, setHitNavigation] = useState(0);
  const productDetailRef = useRef<HTMLDivElement>(null);
  const reviewRef = useRef<HTMLDivElement>(null);
  const productInfoRef = useRef<HTMLDivElement>(null);
  function handleScroll(num: number) {
    if (
      !productDetailRef.current ||
      !reviewRef.current ||
      !productInfoRef.current
    )
      return;
    let height = isDesktop ? 207 : 102;
    if (num == 0) {
      window.scrollTo({
        top: productDetailRef.current.offsetTop - height,
      });
    } else if (num == 1) {
      window.scrollTo({
        top: reviewRef.current.offsetTop - height,
      });
    } else if (num == 2) {
      window.scrollTo({
        top: productInfoRef.current.offsetTop - height,
      });
    }
  }
  // 네비게이션 바 관련

  // 스크롤 위치 네비게이션 바 보다 하단일시 상단 고정 구매 탭 관련
  const [isFixed, setIsFixed] = useState(false);
  const [fixedFormOpen, setFixedFormOpen] = useState(false);
  useEffect(() => {
    if (isMobile && fixedFormOpen) document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [fixedFormOpen]);
  const navigationBarLocationRef = useRef<HTMLDivElement>(null);
  const throttledScroll = useMemo(
    () =>
      throttle(() => {
        if (
          !navigationBarLocationRef.current ||
          !reviewRef.current ||
          !productInfoRef.current
        )
          return;
        if (window.scrollY > navigationBarLocationRef.current.offsetTop)
          setIsFixed(true);
        else setIsFixed(false);
        if (window.scrollY < reviewRef.current.offsetTop - 207)
          setHitNavigation(0);
        else if (window.scrollY + 207 < productInfoRef.current.offsetTop - 207)
          setHitNavigation(1);
        else setHitNavigation(2);
      }, 500),
    [],
  );
  useEffect(() => {
    window.addEventListener('scroll', throttledScroll);
    return () => {
      window.removeEventListener('scroll', throttledScroll);
    };
  }, [throttledScroll]);
  // 스크롤 위치 네비게이션 바 보다 하단일시 상단 고정 구매 탭 관련
  const [nonfaceProcessOpen, setNonfaceProcessOpen] = useState(false);
  function handleBuy() {
    if (!saleDateCheck()) return;
    if (!needLogin()) return;
    let check = optionSelectCheck();
    if (!check) return;
    let formData = getBasketFormData() as FormData;
    formData.append('is_direct', 'Y');
    axiosClient
      .post('/func/cart', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((res) => {
        if (res.data.data.cart_ids[0].message) {
          alert(res.data.data.cart_ids[0].message);
          return;
        }
        let idList: number[] = [];
        res.data.data.cart_ids.map(
          (ids: { status: number; cart_id: number }) => {
            idList.push(ids.cart_id);
          },
        );
        let queryString = JSON.stringify(idList);
        if (detail?.is_prescription == 1)
          navigate(`/questionnaire/Y/${queryString}`);
        else navigate(`/order/Y/${queryString}`);
      });
  }
  //모바일로 접속시 제풍상세 하단탭 높이만큼 body padding-bottom증가
  useEffect(() => {
    if (!isDesktop)
      document.body.style.paddingBottom =
        'calc(env(safe-area-inset-bottom) + 128px)';
    return () => {
      document.body.style.paddingBottom =
        'calc(env(safe-area-inset-bottom) + 64px)';
    };
  }, []);
  //모바일로 접속시 제풍상세 하단탭 높이만큼 body padding-bottom증가

  //첫 렌더링시 리뷰데이터 생성(리뷰 컴포넌트에서 작성 시 리뷰 컴포넌트 두 개라 동일한 요청 두 개씩 발생해서 상위 컴포넌트에서 첫 리뷰 데이터 호출)
  const [reviewData, setReviewData] = useState<IReviewDataType[]>([]);
  const [reviewCount, setReviewCount] = useState(0);
  useEffect(() => {
    //첫 렌더링시 일반 리뷰 데이터 조회
    if (!detail) return;
    axiosClient
      .get(
        `/data/product_talk/list?&talk_type=상품평가&offset=0&limit=3&product_id=${params.productId}&order_by=star`,
      )
      .then((res) => {
        setReviewData(res.data.data);
        setReviewCount(res.data.total_count);
      });
  }, [detail]);
  const [photoReviewData, setPhotoReviewData] = useState<IReviewDataType[]>([]);
  const [photoReviewCount, setPhotoReviewCount] = useState(0);
  useEffect(() => {
    //첫 렌더링시 포토 리뷰 데이터 조회
    if (!detail || !reviewData.length) return;
    axiosClient
      .get(
        `/data/product_talk/photo-review-list?&talk_type=상품평가&offset=0&limit=15&product_id=${params.productId}&order_by=order`,
      )
      .then((res) => {
        setPhotoReviewData(res.data.data);
        setPhotoReviewCount(res.data.total_count);
      });
  }, [detail, reviewData]);
  //첫 렌더링시 리뷰데이터 생성(리뷰 컴포넌트에서 작성 시 리뷰 컴포넌트 두 개라 동일한 요청 두 개씩 발생해서 상위 컴포넌트에서 첫 리뷰 데이터 호출)

  const connectToChannelIO = () => {
    if ((window as any).ChannelIO) (window as any).ChannelIO('openChat');
  };
  
  const productDescriptions = [
    {
      title: t('productDetail.58'),
      introduction: t('productDetail.59'),
      benefits: [
        t('productDetail.60'),
        t('productDetail.61'),
        t('productDetail.90'),
        t('productDetail.62'),
      ],
      boxContents: t('productDetail.63'),
      tasteAndAroma: [
        t('productDetail.64'),
        t('productDetail.65')
      ],
      usage: [
        t('productDetail.66'),
        t('productDetail.67'),
        t('productDetail.68')
      ],
      thumbnailImages: [
        gambichDetail1, gambichDetail3, gambichDetail4, gambichDetail2
      ],
      thumbnailImagesMobile: [
        gambichDetailMobile1, gambichDetailMobile2, gambichDetailMobile3, gambichDetailMobile4
      ],
      matchCondition: (title: string) => title.includes('감비차'),
    },
    {
      title: t('productDetail.69'),
      introduction: t('productDetail.70'),
      benefits: [
        t('productDetail.71'),
        t('productDetail.72'),
        t('productDetail.73'),
        t('productDetail.74')
      ],
      boxContents: t('productDetail.75'),
      tasteAndAroma: [
        t('productDetail.76')
      ],
      usage: [
        t('productDetail.77'),
        t('productDetail.78')
      ],
      thumbnailImages: [
        biumhwanDetail1, biumhwanDetail2, biumhwanDetail3, biumhwanDetail4
      ],
      thumbnailImagesMobile: [
        biumhwanDeatilMobile1, biumhwanDeatilMobile2, biumhwanDeatilMobile3, biumhwanDeatilMobile4
      ],
      matchCondition: (title: string) => title.includes('비움환'),
    },
    {
      title: t('productDetail.79'),
      introduction: t('productDetail.80'),
      benefits: [
        t('productDetail.81'),
        t('productDetail.82'),
        t('productDetail.83'),
        t('productDetail.84')
      ],
      boxContents: t('productDetail.85'),
      tasteAndAroma: [
        t('productDetail.86'),
        t('productDetail.87')
      ],
      usage: [
        t('productDetail.88'),
        t('productDetail.89')
      ],
      thumbnailImages: [
        cheongdamDetail1, cheongdamDetail2, cheongdamDetail3, cheongdamDetail4
      ],
      thumbnailImagesMobile: [
        cheongdamDetailMobile1, cheongdamDetailMobile2, cheongdamDetailMobile3, cheongdamDetailMobile4 
      ],
      matchCondition: (title: string) =>
        title.includes('타블렛') || title.toLowerCase().includes('tablet'),
    }
  ];
  const ProductDescription: React.FC<ProductDescriptionProps> = ({ detail }) => {
    const product = productDescriptions.find((product) =>
      product.matchCondition(detail.title)
    );
  
    if (!product) return null;
  
    return (
      <div className={styles.description}>
        <h3>{product.title}</h3>
        <p>{product.introduction}</p>
  
        <ul>
          {product.benefits.map((benefit, index) => (
            <li key={index}>{benefit}</li>
          ))}
        </ul>
  
        <h4>What’s inside the Box?</h4>
        <p>{product.boxContents}</p>
  
        <h4>What does it taste and Aroma like?</h4>
        <ul>
          {product.tasteAndAroma.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
  
        <h4>How to Enjoy:</h4>
        <ul>
          {product.usage.map((method, index) => (
            <li key={index}>{method}</li>
          ))}
        </ul>
      </div>
    );
  };

  const [validImages, setValidImages] = useState<string[]>([]);

  useEffect(() => {
    if (!isMobile || !detail) return;
  
    const rawImageUrls = [
      detail?.image2,
      detail?.image3,
      detail?.image4,
      detail?.image5,
    ].filter(Boolean);
  
    const checkImages = async () => {
      const promises = rawImageUrls.map(
        (url) =>
          new Promise<string | null>((resolve) => {
            const img = new Image();
            img.onload = () => resolve(url);
            img.onerror = () => resolve(null);
            img.src = url;
          }),
      );
  
      Promise.all(promises).then((results) => {
        const filtered = results.filter(Boolean) as string[];
        setValidImages(filtered);
      });
    };
  
    checkImages();
  }, [isMobile, detail]);

  return (
    <div>
      <Header />
      <div className={styles.productContainer}>
        <div className={styles.thumbnailWrap}>
          {detail?.title && (
            isMobile ? (
              validImages.length > 0 && (
                <div className={styles.mobileSwiperContainer}>
                  <div className={styles.imageIndexBox}>
                    {activeIndex} / {validImages.length}
                  </div>
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    pagination={{ clickable: true }}
                    className={styles.mobileSwiper}
                    onSlideChange={(swiper) =>
                      setActiveIndex(swiper.activeIndex + 1)
                    }
                  >
                    {validImages.map((image, idx) => (
                      <SwiperSlide key={idx}>
                        <img
                          src={image}
                          alt={`mobile-thumbnail-${idx}`}
                          className={styles.mobileImage}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              )
            ) : (
              <>
                {detail.image2 && (
                  <img
                    src={detail.image2}
                    alt="thumbnail"
                    className={styles.mainImage}
                  />
                )}
                {detail.image3 && (
                  <img
                    src={detail.image3}
                    alt="additional1"
                    className={styles.subImage}
                    onError={(e) => (e.currentTarget.style.display = 'none')}
                  />
                )}
                <div className={styles.gridRow}>
                  {detail.image4 && (
                    <img
                      src={detail.image4}
                      alt="additional2"
                      className={styles.halfImage}
                      onError={(e) => (e.currentTarget.style.display = 'none')}
                    />
                  )}
                  {detail.image5 && (
                    <img
                      src={detail.image5}
                      alt="additional3"
                      className={styles.halfImage}
                      onError={(e) => (e.currentTarget.style.display = 'none')}
                    />
                  )}
                </div>
              </>
            )
          )}
        </div>
        <div className={styles.productInfoWrap}>
          <span className={styles.productName}>{detail && detail.title}</span>
          {detail && detail.review_score_avg && (
            <div className={styles.scoreWrap}>
              <ul>
                {(() => {
                  let list: boolean[] = [];
                  for (let i = 1; i <= 5; i++) {
                    if (
                      i <=
                      Math.round(
                        detail.review_score_avg.review_point_total_avg / 2,
                      )
                    )
                      list.push(true);
                    else list.push(false);
                  }
                  return list.map((isTrue, idx) => {
                    if (isTrue)
                      return (
                        <li key={idx}>
                          <img src={star} alt="star" />
                        </li>
                      );
                    else
                      return (
                        <li key={idx}>
                          <img src={emptyStar} alt="star" />
                        </li>
                      );
                  });
                })()}
              </ul>
              <span className={styles.reviewCount}>
                (
                {Math.floor(
                  (detail.review_score_avg.review_point_total_avg / 2) * 10,
                ) / 10}
                )
              </span>
            </div>
          )}
          <div className={styles.priceInfoWrap}>
            <div
              className={`${styles.priceWrap} ${
                !(detail?.discount_price !== detail?.price && detail?.price !== 0)
                  ? styles.nosale
                  : ''
              }`}
            >
              <span>{t('productDetail.1')}</span>
              <span>
                {detail && (
                  <>
                    {detail.discount_price && detail.discount_price > 0 && detail.price !== detail.discount_price ? (
                      <>
                        {detail.price !== 0 && (
                          <span style={{ textDecoration: 'line-through', marginRight: '5px', color: '#999' }}>
                            {'$' + detail.price.toLocaleString()}
                          </span>
                        )}
                        <span>{'$' + detail.discount_price.toLocaleString()}</span>
                      </>
                    ) : (
                      <span>
                        {detail.price !== 0
                          ? '$' + detail.price.toLocaleString()
                          : '$' + detail.discount_price.toLocaleString()}
                      </span>
                    )}
                  </>
                )}
              </span>
            </div>
          </div>
          <div className={styles.optionWrap}>
          {/* 옵션 */}
          {detail && (
            <div className={styles.option}>
              <span>{t('productDetail.3')}</span>
              <div
                className={styles.optionBox}
                onClick={() => setFirstOptionOpen((prev) => !prev)}
              >
                <span
                  style={{
                    color: selectedFirstOption ? '#131C31' : '#abb1bb',
                  }}
                >
                  {selectedFirstOption
                    ? selectedFirstOption.po_poptionname
                    : t('productDetail.39')}
                </span>
                <img
                  src={bottomArrow}
                  alt="bottomArrow"
                  style={{
                    transform: firstOptionOpen ? 'rotate(180deg)' : 'none',
                  }}
                />
                {firstOptionOpen && (
                  <ul className={styles.optionList}>
                    {detail.option_depth > 0 ? (
                      firstOptionList?.map((option) => (
                        <li
                          key={option.po_uid}
                          onClick={() => setSelectedFirstOption(option)}
                        >
                          {option.po_poptionname}
                        </li>
                      ))
                    ) : (
                      <li
                        onClick={() =>
                          setSelectedFirstOption({
                            po_poptionname: detail.title,
                            po_poptionprice: detail.discount_price,
                            po_uid: 0,
                          })
                        }
                      >
                        {detail.title}
                      </li>
                    )}
                  </ul>
                )}
              </div>
            </div>
          )}
          {detail && detail.option_depth > 1 && (
            <div className={styles.option}>
              <span>{t('productDetail.3')}</span>
              <div
                className={styles.optionBox}
                onClick={() => {
                  if (!selectedFirstOption) {
                    alert(t('other.34'));
                    setFirstOptionOpen(true);
                    return;
                  }
                  setSecondOptionOpen((prev) => !prev);
                }}
              >
                <span>{t('productDetail.39')}</span>
                <img
                  src={bottomArrow}
                  alt="bottomArrow"
                  style={{
                    transform: secondOptionOpen ? 'rotate(180deg)' : 'none',
                  }}
                />
                {secondOptionOpen && (
                  <ul className={styles.optionList}>
                    {secondOptionList?.map((option) => (
                      <li
                        key={option.po_uid}
                        onClick={() => setSelectedSecondOption(option)}
                      >
                        {option.po_poptionname}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}
          {/* 옵션 */}
        </div>
        {detail?.is_prescription === 1 && (
          <div
            className={`${styles.stepContainer} ${
              isMobile ? styles.isMobile : ''
            }`}
          >
            <div
              className={styles.stepWrap}
              onClick={() => {
                setIsStep(true);
                navigate('?step-recommendation');
              }}
            >
              <div className={styles.stepLeftWrap}>
                <span>{t('productDetail.56')}</span>
                <div>
                  <span>{t('productDetail.57')}</span>
                  <img src={stepDirect} alt="direct" />
                </div>
              </div>
              <img src={step} alt="step" />
            </div>
          </div>
        )}
        {selectedAllItems.length > 0 && (
          <ul className={styles.selectedOptionListWrap}>
            {selectedAllItems.map((option, idx) => (
              <li key={idx}>
                <div className={!isDesktop ? styles.isMobile : ''}>
                  <span className={styles.optionName}>
                    {`${option.first?.po_poptionname}`}
                    {option.second && ` / ${option.second?.po_poptionname}`}
                    {option.third && ` / ${option.third?.po_poptionname}`}
                  </span>
                  <div className={styles.counter}>
                    <div
                      className={styles.minus}
                      onClick={() => handleCountChange(idx, false)}
                    >
                      <img src={minus} alt="minus" />
                    </div>
                    <div className={styles.count}>{option.count}</div>
                    <div
                      className={styles.plus}
                      onClick={() => handleCountChange(idx, true)}
                    >
                      <img src={plus} alt="plus" />
                    </div>
                  </div>
                  <div className={styles.editBox}>
                    <span>
                      {option.third
                        ? '$' + option.third.po_poptionprice?.toLocaleString()
                        : option.second
                        ? '$' + option.second.po_poptionprice?.toLocaleString()
                        : '$' + option.first.po_poptionprice!.toLocaleString()}
                    </span>
                    <img
                      src={closeBtn}
                      alt="closeBtn"
                      onClick={() => handleSelectedItemDelete(idx)}
                    />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
        <div className={styles.totalPriceWrap}>
          <span className={styles.head}>{t('productDetail.40')}</span>
          <span className={styles.totalPrice}>
            <span>${allItemsPrice.toLocaleString()}</span>
            <span>{allItemsCount !== 0 && `(Quantity ${allItemsCount})`}</span>
          </span>
        </div>
        <div className={styles.btnsWrap}>
          <div className={styles.pickBtn} onClick={handlePick}>
            <img
              src={detail && detail.is_like == 0 ? heart : redHeart}
              alt="heart"
            />
          </div>
          <div className={styles.basketBtn} onClick={handleBasket}>
            <img src={basket} alt="basket" />
            <span>{t('productDetail.42')}</span>
          </div>
          <div className={styles.buyBtn} onClick={handleBuy}>
            {t('productDetail.41')}
          </div>
        </div>
        </div>
      </div>
      {/* <div ref={fixedBuyHandler}></div> */}
      <div
        className={`${styles.bannersWrap} ${!isDesktop ? styles.isMobile : ''}`}
      >
        {/* <div className={styles.kakaoEventBanner}>
          <span>플러스친구 등록 3000원 쿠폰 💌</span>
        </div> */}
        {detail?.is_prescription == 1 && (
          <div
            className={`${styles.nonFaceProcess} ${
              isMobile ? styles.isMobile : ''
            }`}
          >
            <div
              className={styles.banner}
              onClick={() => setNonfaceProcessOpen((prev) => !prev)}
            >
              <span>{t('productDetail.4')}</span>
              <img
                src={bottomArrow2}
                alt="bottomArrow"
                className={nonfaceProcessOpen ? styles.isOpen : ''}
              />
            </div>
            {nonfaceProcessOpen && (
              <ul className={styles.nonfaceProcessList}>
                <li>
                  <div>
                    <div className={styles.step}>STEP.01</div>
                    <span>{t('home.6')}</span>
                  </div>
                  <span>{t('home.7')}</span>
                </li>
                <li>
                  <div>
                    <div className={styles.step}>STEP.02</div>
                    <span>{t('home.8')}</span>
                  </div>
                  <span>{t('home.9')}</span>
                </li>
                <li>
                  <div>
                    <div className={styles.step}>STEP.03</div>
                    <span>{t('home.14')}</span>
                  </div>
                  <span>{t('home.15')}</span>
                </li>
                <li>
                  <div>
                    <div className={styles.step}>STEP.04</div>
                    <span>{t('home.12')}</span>
                  </div>
                  <span>{t('home.13')}</span>
                </li>
              </ul>
            )}
          </div>
        )}
      </div>
      {/* <LazyLoad>
        <Review
          type="first"
          allReviewData={detail?.review_score_avg}
          firstReviewData={reviewData}
          firstReviewCount={reviewCount}
          firstPhotoReviewData={photoReviewData}
          firstPhotoReviewCount={photoReviewCount}
          product={detail}
        />
      </LazyLoad> */}
      <ul className={styles.navigationBar}>
        <li
          className={hitNavigation == 0 ? styles.hit : ''}
          onClick={() => handleScroll(0)}
        >
          {t('productDetail.15')}
        </li>
        <li
          className={hitNavigation == 1 ? styles.hit : ''}
          onClick={() => handleScroll(1)}
        >
          {t('productDetail.16')}
        </li>
        <li
          className={hitNavigation == 2 ? styles.hit : ''}
          onClick={() => handleScroll(2)}
        >
          {t('productDetail.17')}
        </li>
      </ul>
      <div ref={navigationBarLocationRef}></div>
      <div className={styles.couponSection}>
        <div 
          className={styles.ticketWrap}
          onClick={() => generateCoupon(1)}
        >
          <img src={couponTicket} alt="coupon" className={styles.ticketImage} />
          <div className={styles.textArea}>
            <p>{t('productDetail.92')}</p>
            <p className={styles.freeShip}>{t('productDetail.93')}</p>
            <p>{t('productDetail.94')} <strong>{t('productDetail.95')}</strong></p>
          </div>
          <p className={styles.validText}>{t('productDetail.96')}</p>
        </div>
      </div>
      <div className={styles.productDetail} ref={productDetailRef}>
        {detail && detail.title.includes('청담보감 다이어트') && (
          <div
            className={`${styles.solution} ${
              isMobile ? styles.mobileSolution : styles.pcSolution
            }`}
          >
            <span>{t('productDetail.18')}</span>
            <p>{t('productDetail.19')}</p>
            <p>{t('productDetail.20')}</p>
            <div className={styles.reviewSliderWrap}>
              <span>{t('productDetail.21')}</span>
              <div className={styles.reviewSlider}>
                {/* {!loginCheck() && <ReviewFilter />} */}
                <Swiper
                  slidesPerView={isDesktop ? 2.2 : 1}
                  scrollbar={{ draggable: true, dragSize: 170 }}
                  breakpoints={{
                    700: {
                      // slidesPerView: 2.2,
                      scrollbar: { dragSize: 259 },
                    },
                  }}
                >
                  <SwiperSlide>
                    <div className={styles.slideWrap}>
                      <img src={review01} alt="reviewImage" />
                      <div className={styles.reviewInfo}>
                        <p className={styles.content}>
                          {t('productDetail.22')}
                        </p>
                        <div className={styles.userInfoWrap}>
                          <span>{t('productDetail.23')}</span>
                          <span>
                            {t('productDetail.34')} / {t('productDetail.37')} /{' '}
                            {t('productDetail.12')} -6.5kg
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.slideWrap}>
                      <img src={review02} alt="reviewImage" />
                      <div className={styles.reviewInfo}>
                        <p className={styles.content}>
                          {t('productDetail.24')}
                        </p>
                        <div className={styles.userInfoWrap}>
                          <span>{t('productDetail.25')}</span>
                          <span>
                            {t('productDetail.33')} / {t('productDetail.37')} /{' '}
                            {t('productDetail.12')} -4kg
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.slideWrap}>
                      <img src={review03} alt="reviewImage" />
                      <div className={styles.reviewInfo}>
                        <p className={styles.content}>
                          {t('productDetail.26')}
                        </p>
                        <div className={styles.userInfoWrap}>
                          <span>{t('productDetail.27')}</span>
                          <span>
                            {t('productDetail.32')} / {t('productDetail.37')} /{' '}
                            {t('productDetail.12')} -4kg
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.slideWrap}>
                      <img src={review04} alt="reviewImage" />
                      <div className={styles.reviewInfo}>
                        <p className={styles.content}>
                          {t('productDetail.28')}
                        </p>
                        <div className={styles.userInfoWrap}>
                          <span>{t('productDetail.29')}</span>
                          <span>
                            {t('productDetail.33')} / {t('productDetail.37')} /{' '}
                            {t('productDetail.12')} -3kg
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.slideWrap}>
                      <img src={review05} alt="reviewImage" />
                      <div className={styles.reviewInfo}>
                        <p className={styles.content}>
                          {t('productDetail.30')}
                        </p>
                        <div className={styles.userInfoWrap}>
                          <span>{t('productDetail.31')}</span>
                          <span>
                            {t('productDetail.33')} / {t('productDetail.36')} /{' '}
                            {t('productDetail.12')} -6kg
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        )}
        <LazyLoad>
          <div
            dangerouslySetInnerHTML={{
              __html: detail ? detail.content.replace(/\\/gi, '') : '',
            }}
          ></div>
        </LazyLoad>
      </div>
      <div ref={reviewRef}></div>
      <LazyLoad>
        <Review
          allReviewData={detail?.review_score_avg}
          firstReviewData={reviewData}
          firstReviewCount={reviewCount}
          firstPhotoReviewData={photoReviewData}
          firstPhotoReviewCount={photoReviewCount}
          product={detail}
        />
      </LazyLoad>
      <div className={styles.productInfoArea} ref={productInfoRef}>
        <h3>{t('productDetail.46')}</h3>
      </div>
      {detail && <ProductDescription detail={detail} />}
      <div className={`${styles.bannerWrap} ${isMobile ? styles.isMobile : ''}`}>
        <div className={styles.mypageWrap}>
          <span>You can find your tracking number in </span>
          <br />
          <span className={styles.hit}>My Page - Orders and deliveries.</span>
        </div>
        <div className={styles.emailWrap}>
          <span className={styles.hit}>A tracking number will be emailed</span>
          <br />
          <span> to you once the product has shipped.</span>
          <br />
          <div className={styles.checkText}>
            <span>Please check your </span>
            <br />
            <span className={styles.hit}>spam folder</span>
            <span> as the email may end up there.</span>
          </div>
        </div>
        <div className={styles.contentWrap}>
          <span>For delivery inquiries and</span>
          <span>other inquiries,</span>
          <br />
          <span>please contact us through</span>
          <br />
          <span className={styles.hit}>Channel Talk.</span>
          <div className={styles.kakaoIdWrap} onClick={connectToChannelIO}>
            <div>
              <p>Connect to customer Service</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.shippingDetailArea}>
        <div className={styles.deliveryInfo}>
          <h4>{t('productDetail.44')}</h4>
          <ul className={styles.deliveryInfoList}>
            <li>
              <span>{t('productDetail.51')}</span>
              <span>Fedex</span>
            </li>
            <li>
              <span>{t('productDetail.52')}</span>
              <span>
                {t('productDetail.54')}
                {/* {detail?.delivery_case_price ? (
                  <>
                    {detail?.delivery_case_price.toLocaleString()}원 이상
                    무료배송
                  </>
                ) : (
                  ''
                )} */}
                {/* <br /> */}
                {/* (도서산간 지역에 따라 추가 배송비가 발생할 수 있습니다.) */}
              </span>
            </li>
            <li>
              <span>{t('productDetail.53')}</span>
              <span>
                On average, it takes about 7 to 10 business days from the order
                date.
                <br />
                Delivery may be delayed due to weekends, holidays, order surges,
                and courier company circumstances.
              </span>
            </li>
          </ul>
        </div>
        <div className={styles.exchangeInfo}>
          <h4>{t('productDetail.45')}</h4>
          <span>Please contact the customer service center.</span>
        </div>
      </div>
      <Footer />
      {isFixed && (
        <div className={styles.fixedContents}>
          {isDesktop && (
            <>
              <div className={styles.productInfoSection}>
                <div className={styles.left}>
                  <div className={styles.productImg}>
                    {detail && <img src={detail?.list_image} alt="thumbnail" />}
                  </div>
                  <div className={styles.productInfo}>
                    <span>{detail?.title}</span>
                    <div className={styles.priceInfo}>
                      <span className={styles.discountPrice}>
                        ${detail?.discount_price.toLocaleString()}
                      </span>
                      {detail?.price !== 0 &&
                        detail?.price !== detail?.discount_price && (
                          <span className={styles.price}>
                            ${detail?.price.toLocaleString()}
                          </span>
                        )}
                    </div>
                  </div>
                </div>
                {fixedFormOpen ? (
                  <div
                    className={styles.formCloseBtn}
                    onClick={() => setFixedFormOpen(false)}
                  >
                    {t('productDetail.38')}
                  </div>
                ) : (
                  <div
                    className={styles.formOpenBtn}
                    onClick={() => setFixedFormOpen(true)}
                  >
                    {t('productDetail.41')}
                  </div>
                )}
              </div>
              {fixedFormOpen && (
                <div className={styles.optionSelectSection}>
                  <div className={styles.left}>
                    <ul className={styles.optionSelectList}>
                      {detail && (
                        <li>
                          <span>{t('productDetail.3')}</span>
                          <div
                            className={styles.optionBox}
                            onClick={() => setFirstOptionOpen((prev) => !prev)}
                          >
                            <span
                              style={{
                                color: selectedFirstOption
                                  ? '#131C31'
                                  : '#abb1bb',
                              }}
                            >
                              {selectedFirstOption
                                ? selectedFirstOption.po_poptionname
                                : t('productDetail.39')}
                            </span>
                            <img src={bottomArrow} alt="arrow" />
                            {firstOptionOpen && (
                              <ul className={styles.optionList}>
                                {detail.option_depth > 0 ? (
                                  firstOptionList?.map((option) => (
                                    <li
                                      key={option.po_uid}
                                      onClick={() =>
                                        setSelectedFirstOption(option)
                                      }
                                    >
                                      {option.po_poptionname}
                                    </li>
                                  ))
                                ) : (
                                  <li
                                    onClick={() =>
                                      setSelectedFirstOption({
                                        po_poptionname: detail.title,
                                        po_poptionprice: detail.discount_price,
                                        po_uid: 0,
                                      })
                                    }
                                  >
                                    {detail.title}
                                  </li>
                                )}
                              </ul>
                            )}
                          </div>
                        </li>
                      )}
                      {detail && detail.option_depth > 1 && (
                        <li>
                          <span>{t('productDetail.3')}</span>
                          <div className={styles.optionBox}>
                            <span
                              style={{
                                color: selectedSecondOption
                                  ? '#131C31'
                                  : '#abb1bb',
                              }}
                            >
                              {selectedSecondOption
                                ? selectedSecondOption.po_poptionname
                                : t('productDetail.39')}
                            </span>
                            <img src={bottomArrow} alt="arrow" />
                            {secondOptionOpen && (
                              <ul className={styles.optionList}>
                                {secondOptionList?.map((option) => (
                                  <li
                                    key={option.po_uid}
                                    onClick={() =>
                                      setSelectedSecondOption(option)
                                    }
                                  >
                                    {option.po_poptionname}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </li>
                      )}
                    </ul>
                    <ul className={styles.selectedOptionList}>
                      {selectedAllItems.map((option, idx) => (
                        <li>
                          <span className={styles.productName}>
                            {`${option.first?.po_poptionname}`}
                            {option.second &&
                              ` / ${option.second?.po_poptionname}`}
                            {option.third &&
                              ` / ${option.third?.po_poptionname}`}
                          </span>
                          <div className={styles.counter}>
                            <div
                              className={styles.minus}
                              onClick={() => handleCountChange(idx, false)}
                            >
                              <img src={minus} alt="minus" />
                            </div>
                            <div className={styles.number}>
                              <span>{option.count}</span>
                            </div>
                            <div
                              className={styles.plus}
                              onClick={() => handleCountChange(idx, true)}
                            >
                              <img src={plus} alt="plus" />
                            </div>
                          </div>
                          <div className={styles.price}>
                            <span>
                              $
                              {option.third
                                ? option.third.po_poptionprice?.toLocaleString()
                                : option.second
                                ? option.second.po_poptionprice?.toLocaleString()
                                : option.first.po_poptionprice!.toLocaleString()}
                            </span>
                            <img
                              src={closeBtn}
                              alt="closeBtn"
                              onClick={() => handleSelectedItemDelete(idx)}
                            />
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className={styles.centerLine}></div>
                  <div className={styles.right}>
                    <div className={styles.totalPrice}>
                      <span>{t('productDetail.40')}</span>
                      <div className={styles.price}>
                        <span>${allItemsPrice.toLocaleString()}</span>
                        <span>(Quantity {allItemsCount})</span>
                      </div>
                    </div>
                    <div className={styles.fixedFormBtnsWrap}>
                      <div className={styles.buyBtn} onClick={handleBuy}>
                        {t('productDetail.41')}
                      </div>
                      <div className={styles.pickBtn} onClick={handlePick}>
                        <img
                          src={detail && detail.is_like == 0 ? heart : redHeart}
                          alt="heart"
                        />
                        <span>{t('productDetail.43')}</span>
                      </div>
                      <div className={styles.basketBtn} onClick={handleBasket}>
                        <img src={basket} alt="basket" />
                        <span>{t('productDetail.42')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <ul className={styles.fixedNavigationBar}>
            <li
              className={hitNavigation == 0 ? styles.hit : ''}
              onClick={() => handleScroll(0)}
            >
              {t('productDetail.15')}
            </li>
            <li
              className={hitNavigation == 1 ? styles.hit : ''}
              onClick={() => handleScroll(1)}
            >
              {t('productDetail.16')}
            </li>
            <li
              className={hitNavigation == 2 ? styles.hit : ''}
              onClick={() => handleScroll(2)}
            >
              {t('productDetail.17')}
            </li>
          </ul>
        </div>
      )}
      {isMobile && (
        <div className={styles.mobileBottomTab}>
          <div
            className={`${styles.contentArea} ${
              fixedFormOpen ? styles.isOpen : ''
            }`}
          >
            <div
              className={styles.closeBtnArea}
              onClick={() => setFixedFormOpen(false)}
            >
              <img src={detailFixFormClose} alt="closeBtnImage" />
            </div>
            <div className={styles.optionSelect}>
              {detail && (
                <div className={styles.option}>
                  <span>{t('productDetail.3')}</span>
                  <div
                    className={styles.optionBox}
                    onClick={() => setFirstOptionOpen((prev) => !prev)}
                  >
                    <span
                      style={{
                        color: selectedFirstOption ? '#131C31' : '#abb1bb',
                      }}
                    >
                      {selectedFirstOption
                        ? selectedFirstOption.po_poptionname
                        : t('productDetail.39')}
                    </span>
                    <img
                      src={bottomArrow}
                      alt="arrow"
                      style={{
                        transform: firstOptionOpen ? 'rotate(180deg)' : '',
                      }}
                    />
                  </div>
                  {firstOptionOpen && (
                    <ul className={styles.optionList}>
                      {detail.option_depth > 0 ? (
                        firstOptionList?.map((option) => (
                          <li
                            key={option.po_uid}
                            onClick={() => setSelectedFirstOption(option)}
                          >
                            {option.po_poptionname}
                          </li>
                        ))
                      ) : (
                        <li
                          onClick={() =>
                            setSelectedFirstOption({
                              po_poptionname: detail.title,
                              po_poptionprice: detail.discount_price,
                              po_uid: 0,
                            })
                          }
                        >
                          {detail.title}
                        </li>
                      )}
                    </ul>
                  )}
                </div>
              )}
              {detail && detail.option_depth > 1 && (
                <div className={styles.option}>
                  <span>{t('productDetail.3')}</span>
                  <div className={styles.optionBox}>
                    <span
                      style={{
                        color: selectedSecondOption ? '#131C31' : '#abb1bb',
                      }}
                    >
                      {selectedSecondOption
                        ? selectedSecondOption.po_poptionname
                        : t('productDetail.39')}
                    </span>
                    <img
                      src={bottomArrow}
                      alt="arrow"
                      style={{
                        transform: secondOptionOpen ? 'rotate(180deg)' : '',
                      }}
                    />
                  </div>
                  {secondOptionOpen && (
                    <ul className={styles.optionList}>
                      {secondOptionList?.map((option) => (
                        <li
                          key={option.po_uid}
                          onClick={() => setSelectedSecondOption(option)}
                        >
                          {option.po_poptionname}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
            <ul className={styles.selectedOptionList}>
              {selectedAllItems.map((option, idx) => (
                <li className={styles.selectedOption} key={idx}>
                  <div className={styles.top}>
                    <span>
                      {option.first.po_poptionname}
                      {option.second && ` / ${option.second?.po_poptionname}`}
                      {option.third && ` / ${option.third?.po_poptionname}`}
                    </span>
                    <img
                      src={closeBtn}
                      alt="closeBtn"
                      onClick={() => handleSelectedItemDelete(idx)}
                    />
                  </div>
                  <div className={styles.bottom}>
                    <div className={styles.counterBox}>
                      <div
                        className={styles.minus}
                        onClick={() => handleCountChange(idx, false)}
                      >
                        <img src={minus} alt="minus" />
                      </div>
                      <div className={styles.count}>{option.count}</div>
                      <div
                        className={styles.plus}
                        onClick={() => handleCountChange(idx, true)}
                      >
                        <img src={plus} alt="plus" />
                      </div>
                    </div>
                    <span>
                      $
                      {option.third
                        ? option.third.po_poptionprice?.toLocaleString()
                        : option.second
                        ? option.second.po_poptionprice?.toLocaleString()
                        : option.first.po_poptionprice!.toLocaleString()}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
            <div className={styles.totalPriceInfoWrap}>
              <span>{t('productDetail.40')}</span>
              <div className={styles.totalPrice}>
                <span>${allItemsPrice.toLocaleString()}</span>
                <span>
                  {allItemsCount !== 0 && `(Quantity ${allItemsCount})`}
                </span>
              </div>
            </div>
          </div>

          {!fixedFormOpen && (
            <div className={styles.notOpened}>
              <div className={styles.pickBtn} onClick={handlePick}>
                <img
                  src={detail && detail.is_like == 0 ? heart : redHeart}
                  alt="heart"
                />
              </div>
              <div
                className={styles.openBtn}
                onClick={() => setFixedFormOpen(true)}
              >
                {t('productDetail.41')}
              </div>
            </div>
          )}
          {fixedFormOpen && (
            <div className={styles.opened}>
              <div className={styles.basketBtn} onClick={handleBasket}>
                {t('productDetail.42')}
              </div>
              <div className={styles.buyBtn} onClick={handleBuy}>
                {t('productDetail.41')}
              </div>
            </div>
          )}
        </div>
      )}
      {isStep && (
        <StepModal closer={setIsStep} productId={detail?.product_id} />
      )}
    </div>
  );
}
export default ProductDetail;
